import { InitialAppearance } from "../../components/Animation";

const Satistics = () => {
  return (
    <section
      className="framer-ydfzfl"
      data-framer-name="Statistics"
      id="statistics"
      data-name="Statistics"
    >
      <InitialAppearance
        className="framer-j92mbs outline-none flex flex-col justify-start flex-shrink-0 opacity-100"
        style={{ transform: "prespective(1200px)" }}
        data-framer-component-type="RichTextContainer"
        from={{ top: 0, left: 0 }}
        to={{ top: 0, left: 0 }}
        time={1}
      >
        <h2
          className="framer-text framer-styles-preset-15mg8bp"
          data-styles-preset="IXKxaceG9"
        >
          <span
            data-text-fill="true"
            className="framer-text bg-gradient-to-r from-white to-[#70bfea] !text-[35px] sm:!text-[48px] md:!text-[64px] xl:text-[100px]"
          >
            Our statistics
          </span>
        </h2>
      </InitialAppearance>
      <div
        className="framer-1p3o734"
        data-framer-name="Gradient Overlay"
        data-name="Gradient Overlay"
      />
      <div
        className="framer-jnpwsh !flex-col lg:!flex-row"
        data-framer-name="Statistics"
        data-name="Statistics"
      >
        <InitialAppearance
          className="framer-qhahhd opacity-100 !flex-none !w-full lg:!flex-1 lg:!w-1"
          style={{ transform: "prespective(1200px" }}
          data-border="true"
          data-framer-name="Projects Completed"
          data-name="Projects Completed"
          from={{ top: 100, left: 0 }}
          to={{ top: 0, left: 0 }}
          time={0.3}
        >
          <div
            className="framer-o5cyk3 outline-none flex flex-col justify-start flex-shrink-0 transform-none"
            data-framer-component-type="RichTextContainer"
          >
            <h3
              className="framer-text framer-styles-preset-6ghdir"
              data-styles-preset="E4lBliITk"
            >
              Projects completed
            </h3>
          </div>
          <div className="ssr-variant hidden-r5chz7 hidden-5tblbe hidden-ncoutt !contents">
            <div
              className="framer-1w70u9r outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <h2 className="framer-text text-white">
                <span
                  data-text-fill="true"
                  className="framer-text bg-gradient-to-r from-white to-blue-400 text-[75px] font-medium leading-none tracking-normal"
                >
                  1000+
                </span>
              </h2>
            </div>
          </div>
          <div
            className="framer-82r03i hidden-5tblbe"
            data-framer-name="Line"
            data-name="Line"
          />
          <div
            className="framer-1knc46o hidden-5tblbe outline-none flex flex-col justify-start flex-shrink-0 transform-none"
            data-framer-component-type="RichTextContainer"
          >
            <p
              className="framer-text framer-styles-preset-1otixq8"
              data-styles-preset="Z8KnRQzQq"
            >
              We’ve successfully completed over 1,000 high-quality projects
              during our alpha phase. Each project showcases Codeblaze’s
              efficiency and precision, providing fully functional,
              production-ready applications in record time. Our AI-driven
              platform continues to deliver exceptional results that exceed
              client expectations.
            </p>
          </div>
          <div
            className="framer-b9pcv8"
            data-framer-name="Gradient"
            data-name="Gradient"
          />
        </InitialAppearance>
        <div className="ssr-variant hidden-5tblbe hidden-ncoutt !contents">
          <InitialAppearance
            className="framer-1nseq65 opacity-100 !flex-none !w-full lg:!flex-1 lg:!w-1"
            style={{ transform: "prespective(1200px)" }}
            data-border="true"
            data-framer-name="Satisfied Customers"
            data-name="Satisfied Customers"
            from={{ top: 100, left: 0 }}
            to={{ top: 0, left: 0 }}
            delay={0.3}
            time={0.3}
          >
            <div
              className="framer-vhlhk6 outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <h3
                className="framer-text framer-styles-preset-6ghdir"
                data-styles-preset="E4lBliITk"
              >
                Satisfied customers
              </h3>
            </div>
            <div className="ssr-variant hidden-r5chz7 !contents">
              <div
                className="framer-1qxsy3a outline-none flex flex-col justify-start flex-shrink-0 transform-none"
                data-framer-component-type="RichTextContainer"
              >
                <h2 className="framer-text text-white">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70bafa] font-[Inter Tight] text-[75px] font-medium leading-[1em] tracking-[0px]"
                  >
                    100%
                  </span>
                </h2>
              </div>
            </div>
            <div
              className="framer-oaz681 hidden-5tblbe"
              data-framer-name="Line"
              data-name="Line"
            ></div>
            <div
              className="framer-1gynqu9 hidden-5tblbe outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <p
                className="framer-text framer-styles-preset-1otixq8"
                data-styles-preset="Z8KnRQzQq"
              >
                Our dedication to innovation and quality has resulted in a 100%
                satisfaction rate among our clients. Codeblaze streamlines the
                development process, enabling businesses to launch faster while
                maintaining the highest standards of performance and
                reliability. Every client becomes a partner in our journey to
                revolutionize development.
              </p>
            </div>
            <div
              className="framer-10sjmu5"
              data-framer-name="Gradient"
              data-name="Gradient"
            ></div>
          </InitialAppearance>
        </div>
        <div className="ssr-variant hidden-5tblbe hidden-ncoutt !contents">
          <InitialAppearance
            className="framer-1d2qu70 opacity-100 !flex-none !w-full lg:!flex-1 lg:!w-1"
            style={{ transform: "prespective(1200px)" }}
            data-border="true"
            data-framer-name="Hours Saved per day"
            data-name="Hours Saved per day"
            from={{ top: 100, left: 0 }}
            to={{ top: 0, left: 0 }}
            delay={0.6}
            time={0.3}
          >
            <div
              className="framer-5vs0k6 outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <h3
                className="framer-text framer-styles-preset-6ghdir"
                data-styles-preset="E4lBliITk"
              >
                Hours saved per day
              </h3>
            </div>
            <div className="ssr-variant hidden-r5chz7 !contents">
              <div
                className="framer-1fhc7aj outline-none flex flex-col justify-start flex-shrink-0 transform-none"
                data-framer-component-type="RichTextContainer"
              >
                <h2 className="framer-text text-white">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70B0FA] font-inter-tight text-[75px] font-medium tracking-normal leading-tight"
                  >
                    10h
                  </span>
                </h2>
              </div>
            </div>
            <div
              className="framer-1vm3dnv hidden-5tblbe"
              data-framer-name="Line"
              data-name="Line"
            ></div>
            <div
              className="framer-y2rhmn hidden-5tblbe outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <p
                className="framer-text framer-styles-preset-1otixq8"
                data-styles-preset="Z8KnRQzQq"
              >
                Codeblaze reduces development time by 90%, achieving in 1 hour
                what typically takes a senior developer 10 hours. By automating
                the entire process, our platform saves significant time while
                maintaining precision and delivering production-ready results.
                This efficiency empowers teams to focus on strategy and
                innovation rather than tedious coding tasks.
              </p>
            </div>
            <div
              className="framer-bwse0"
              data-framer-name="Gradient"
              data-name="Gradient"
            ></div>
          </InitialAppearance>
        </div>
        <div className="ssr-variant hidden-5tblbe hidden-ncoutt !contents">
          <InitialAppearance
            className="framer-1v7rpl6 opacity-100 !flex-none !w-full lg:!flex-1 lg:!w-1"
            style={{ transform: "prespective(1200px)" }}
            data-border="true"
            data-framer-name="Cost Saved per Month"
            data-role="Cost Saved per Month"
            from={{ top: 100, left: 0 }}
            to={{ top: 0, left: 0 }}
            delay={0.9}
            time={0.3}
          >
            <div
              className="framer-3rt3ru outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <h3
                className="framer-text framer-styles-preset-6ghdir"
                data-styles-preset="E4lBliITk"
              >
                Cost saved per month
              </h3>
            </div>
            <div className="ssr-variant hidden-r5chz7 !contents">
              <div
                className="framer-m2d1c5 outline-none flex flex-col justify-start flex-shrink-0 transform-none"
                data-framer-component-type="RichTextContainer"
              >
                <h2 className="framer-text text-white">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70B0FA] font-inter-tight text-[75px] font-medium tracking-normal leading-tight"
                  >
                    20k
                  </span>
                </h2>
              </div>
            </div>
            <div
              className="framer-oykecz hidden-5tblbe"
              data-framer-name="Line"
              data-role="Line"
            ></div>
            <div
              className="framer-1h0f7mm hidden-5tblbe outline-none flex flex-col justify-start flex-shrink-0 transform-none"
              data-framer-component-type="RichTextContainer"
            >
              <p
                className="framer-text framer-styles-preset-1otixq8"
                data-styles-preset="Z8KnRQzQq"
              >
                Our platform helps clients save an average of $20,000 per month
                by reducing labor costs and optimizing workflows. With
                Codeblaze’s fully automated processes, businesses can achieve
                high-quality results at a fraction of the traditional
                development cost, making innovation accessible to all.
              </p>
            </div>
            <div
              className="framer-1f5ynlr"
              data-framer-name="Gradient"
              data-role="Gradient"
            ></div>
          </InitialAppearance>
        </div>
      </div>
    </section>
  );
};

export default Satistics;
